// extracted by mini-css-extract-plugin
export default {"head":"List_head__A73Hy","headMain":"List_headMain__pIB7J","pad0":"List_pad0__U9qWT","id":"List_id__fIcZ-","btntbl":"List_btntbl__53Vt+","btns":"List_btns__Ivr1X"};